<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    console.log('241115-1替换pc端下载二维码')
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue